import {DragDropModule} from '@angular/cdk/drag-drop';
import {LayoutModule} from '@angular/cdk/layout';

import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AnimatedCodeEditorModule} from '@open-template-hub/animated-code-editor';
import {ButtonModule} from '@open-template-hub/button';
import {CardModule} from '@open-template-hub/card';
import {HeroModule} from '@open-template-hub/hero';
import {environment} from '../environments/environment';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ProgressBarComponent} from './component/bar/progress-bar/progress-bar.component';
import {AssetCardComponent} from './component/card/asset-card/asset-card.component';
import {BlogHolderCardComponent} from './component/card/blog-holder-card/blog-holder-card.component';
import {
  ContactInformationCardComponent
} from './component/card/contact-information-card/contact-information-card.component';
import {EmployeeCardComponent} from './component/card/employee-card/employee-card.component';
import {FeatureCardComponent} from './component/card/feature-card/feature-card.component';
import {PolicyCardComponent} from './component/card/policy-card/policy-card.component';
import {PresentationCardComponent} from './component/card/presentation-card/presentation-card.component';
import {ColorWidgetComponent} from './component/color-widget/color-widget.component';
import {ConverterHeroComponent} from './component/converter-hero/converter-hero.component';
import {PaletteWidgetComponent} from './component/palette-widget/palette-widget.component';
import {GradientWidgetComponent} from './component/gradient-widget/gradient-widget.component';
import {WallpaperWidgetComponent} from './component/wallpaper-widget/wallpaper-widget.component';
import {CodeImageWidgetComponent} from './component/code-image-widget/code-image-widget.component';
import {CodigrateLoaderComponent} from './component/codigrate-loader/codigrate-loader.component';
import {ReviewCardComponent} from './component/card/review-card/review-card.component';
import { ReviewWallComponent } from './component/card/review-wall/review-wall.component';
import {TestimonialCardComponent} from './component/card/testimonial-card/testimonial-card.component';
import {ColorChartComponent} from './component/color-chart/color-chart.component';
import {BoxContentLoaderComponent} from './component/content-loader/box-content-loader/box-content-loader.component';
import {ContentLoaderComponent} from './component/content-loader/content-loader.component';
import {
  ImageContentLoaderComponent
} from './component/content-loader/image-content-loader/image-content-loader.component';
import {
  TextContentLoaderComponent
} from './component/content-loader/text-content-loader/text-content-loader.component';
import {ArrowLeftComponent} from './component/design/arrow/arrow-left/arrow-left.component';
import {ArrowRightComponent} from './component/design/arrow/arrow-right/arrow-right.component';
import {DropdownMenuComponent} from './component/dropdown-menu/dropdown-menu.component';
import {ExtLinkComponent} from './component/ext-link/ext-link.component';
import {BottomNavComponent} from './component/nav/bottom-nav/bottom-nav.component';
import {BannerNotesComponent} from './component/banner-notes/banner-notes.component';
import {BannerComponent} from './component/banner/banner.component';
import {BadgeComponent} from './component/badge/badge.component';
import {FreeFlagComponent} from './component/free-flag/free-flag.component';
import {FooterComponent} from './component/nav/footer/footer.component';
import {IconComponent} from './component/icon/icon.component';
import {
  LandingLayoutTopNavComponent
} from './component/nav/landing/landing-layout-top-nav/landing-layout-top-nav.component';
import {CookiePopupComponent} from './component/popup/cookie-popup/cookie-popup.component';
import {ThemeOfferPopupComponent} from './component/popup/theme-offer-popup/theme-offer-popup.component';
import {RequestInterceptor} from './interceptor/request/request.interceptor';
import {ResponseInterceptor} from './interceptor/response/response.interceptor';
import {BrandingPageComponent} from './page/landing-layout/branding-page/branding-page.component';
import {ContactUsPageComponent} from './page/landing-layout/contact-us-page/contact-us-page.component';
import {HomePageComponent} from './page/landing-layout/home-page/home-page.component';
import {HeroCircuitComponent} from './component/design/hero-circuit/hero-circuit.component';
import {HeroAuroraComponent} from './component/design/hero-aurora/hero-aurora.component';
import {HeroSakuraComponent} from './component/design/hero-sakura/hero-sakura.component';
import {HeroAutumnComponent} from './component/design/hero-autumn/hero-autumn.component';
import {HeroEverestComponent} from './component/design/hero-everest/hero-everest.component';
import {HeroSequoiaComponent} from './component/design/hero-sequoia/hero-sequoia.component';
import {HeroRoraimaComponent} from './component/design/hero-roraima/hero-roraima.component';
import {HeroSaldaComponent} from './component/design/hero-salda/hero-salda.component';
import {HeroOceanComponent} from './component/design/hero-ocean/hero-ocean.component';
import {HeroSpringComponent} from './component/design/hero-spring/hero-spring.component';
import {HeroReynisfjaraComponent} from './component/design/hero-reynisfjara/hero-reynisfjara.component';
import {HeroFujiComponent} from './component/design/hero-fuji/hero-fuji.component';
import {HeroEtnaComponent} from './component/design/hero-etna/hero-etna.component';
import {HeroIstanbulComponent} from './component/design/hero-istanbul/hero-istanbul.component';
import {HeroMiamiComponent} from './component/design/hero-miami/hero-miami.component';
import {HeroRioDeJaneiroComponent} from './component/design/hero-rio-de-janeiro/hero-rio-de-janeiro.component';
import {HeroParisComponent} from './component/design/hero-paris/hero-paris.component';
import {HeroTallinnComponent} from './component/design/hero-tallinn/hero-tallinn.component';
import {HeroTokyoComponent} from './component/design/hero-tokyo/hero-tokyo.component';
import {HeroSydneyComponent} from './component/design/hero-sydney/hero-sydney.component';
import {HeroPragueComponent} from './component/design/hero-prague/hero-prague.component';
import {HeroMadridComponent} from './component/design/hero-madrid/hero-madrid.component';
import {HeroViennaComponent} from './component/design/hero-vienna/hero-vienna.component';
import {HeroDublinComponent} from './component/design/hero-dublin/hero-dublin.component';
import {HeroLondonComponent} from './component/design/hero-london/hero-london.component';
import {HeroBioluminescenceComponent} from './component/design/hero-bioluminescence/hero-bioluminescence.component';
import {ProductShowcaseComponent} from './component/product/product-showcase/product-showcase.component';
import {ThemeShowcaseComponent} from './component/product/theme-showcase/theme-showcase.component';
import {ReviewShowcaseComponent} from './component/product/review-showcase/review-showcase.component';
import {CoverageMatrixComponent} from './component/product/coverage-matrix/coverage-matrix.component';
import {ToolsShowcaseComponent} from './component/product/tools-showcase/tools-showcase.component';
import {PaletteShowcaseComponent} from './component/product/palette-showcase/palette-showcase.component';
import {BlogShowcaseComponent} from './component/product/blog-showcase/blog-showcase.component';
import {LandingLayoutComponent} from './page/landing-layout/landing-layout.component';
import {
  CookiePolicyPageComponent
} from './page/landing-layout/policy-pages/cookie-policy-page/cookie-policy-page.component';
import {
  PrivacyPolicyPageComponent
} from './page/landing-layout/policy-pages/privacy-policy-page/privacy-policy-page.component';
import {TermsPageComponent} from './page/landing-layout/policy-pages/terms-page/terms-page.component';
import {LangmiPageComponent} from './page/landing-layout/langmi-page/langmi-page.component';
import {
  LangmiPrivacyPageComponent
} from './page/landing-layout/policy-pages/langmi-privacy-page/langmi-privacy-page.component';
import {
  LangmiPrivacyLocalizedPageComponent
} from './page/landing-layout/policy-pages/langmi-privacy-localized-page/langmi-privacy-localized-page.component';
import {
  LangmiTermsPageComponent
} from './page/landing-layout/policy-pages/langmi-terms-page/langmi-terms-page.component';
import {
  LangmiTeacherTermsPageComponent
} from './page/landing-layout/policy-pages/langmi-teacher-terms-page/langmi-teacher-terms-page.component';
import {ThemeLicensePageComponent} from './page/landing-layout/policy-pages/theme-license-page/theme-license-page.component';
import {ThemePrivacyPageComponent} from './page/landing-layout/policy-pages/theme-privacy-page/theme-privacy-page.component';
import {DockTownPrivacyPageComponent} from './page/landing-layout/policy-pages/dock-town-privacy-page/dock-town-privacy-page.component';
import {TidyDesktopPrivacyPageComponent} from './page/landing-layout/policy-pages/tidy-desktop-privacy-page/tidy-desktop-privacy-page.component';
import {
  MaintenancePageComponent
} from './page/landing-layout/raw-content-pages/maintenance-page/maintenance-page.component';
import {NotFoundPageComponent} from './page/landing-layout/raw-content-pages/not-found-page/not-found-page.component';
import {SitemapPageComponent} from './page/landing-layout/sitemap-page/sitemap-page.component';
import {ColorPageComponent} from './page/landing-layout/tool-pages/color-page/color-page.component';
import {PalettePageComponent} from './page/landing-layout/tool-pages/palette-page/palette-page.component';
import {GradientPageComponent} from './page/landing-layout/tool-pages/gradient-page/gradient-page.component';
import {WallpaperPageComponent} from './page/landing-layout/tool-pages/wallpaper-page/wallpaper-page.component';
import {DynamicWallpaperPageComponent} from './page/landing-layout/tool-pages/dynamic-wallpaper-page/dynamic-wallpaper-page.component';
import {CodeImagePageComponent} from './page/landing-layout/tool-pages/code-image-page/code-image-page.component';
import {ContrastPageComponent} from './page/landing-layout/tool-pages/contrast-page/contrast-page.component';
import {CvdPageComponent} from './page/landing-layout/tool-pages/cvd-page/cvd-page.component';
import {AiCostWidgetComponent} from './component/ai-cost-widget/ai-cost-widget.component';
import {AiPriceWatchWidgetComponent} from './component/ai-price-watch-widget/ai-price-watch-widget.component';
import {AiCostPageComponent} from './page/landing-layout/tool-pages/ai-cost-page/ai-cost-page.component';
import {AiPriceWatchPageComponent} from './page/landing-layout/tool-pages/ai-price-watch-page/ai-price-watch-page.component';
import {CvdWidgetComponent} from './component/cvd-widget/cvd-widget.component';
import {ContrastWidgetComponent} from './component/contrast-widget/contrast-widget.component';
import {ToolAboutComponent} from './component/tool-about/tool-about.component';
import {MoreToolsComponent} from './component/more-tools/more-tools.component';
import {ConverterPageComponent} from './page/landing-layout/tool-pages/converter-page/converter-page.component';
import {ToolsPageComponent} from './page/landing-layout/tool-pages/tools-page/tools-page.component';
import {ChromeColorPickerPageComponent} from './page/landing-layout/tool-pages/chrome-color-picker-page/chrome-color-picker-page.component';
import {JetbrainsColorPickerPageComponent} from './page/landing-layout/tool-pages/jetbrains-color-picker-page/jetbrains-color-picker-page.component';
import {VscodeColorPickerPageComponent} from './page/landing-layout/tool-pages/vscode-color-picker-page/vscode-color-picker-page.component';
import {MacosColorPickerPageComponent} from './page/landing-layout/tool-pages/macos-color-picker-page/macos-color-picker-page.component';
import {MacosTidyDesktopPageComponent} from './page/landing-layout/tool-pages/macos-tidy-desktop-page/macos-tidy-desktop-page.component';
import {MacosDockTownPageComponent} from './page/landing-layout/tool-pages/macos-dock-town-page/macos-dock-town-page.component';
import {MacosAiTokenMeterPageComponent} from './page/landing-layout/tool-pages/macos-ai-token-meter-page/macos-ai-token-meter-page.component';
import {AiTokenMeterPrivacyPageComponent} from './page/landing-layout/policy-pages/ai-token-meter-privacy-page/ai-token-meter-privacy-page.component';
import {AllInOneThemesPageComponent} from './page/landing-layout/tool-pages/all-in-one-themes-page/all-in-one-themes-page.component';
import {PluginsPageComponent} from './page/landing-layout/plugin-pages/plugins-page/plugins-page.component';
import {ToolsLayoutComponent} from './page/landing-layout/tool-pages/tools-layout.component';
import {
  ExternalRedirectPageComponent
} from './page/splash-layout/external-redirect-page/external-redirect-page.component';
import {SplashLayoutComponent} from './page/splash-layout/splash-layout.component';
import {ThemesPageComponent} from './page/landing-layout/themes-page/themes-page.component';
import {PalettesPageComponent} from './page/landing-layout/palettes-page/palettes-page.component';
import {ColorPalettePageComponent} from './page/landing-layout/color-palette-page/color-palette-page.component';
import {ThemeCardComponent} from './component/card/theme-card/theme-card.component';
import {ColorDetailComponent} from './component/color-detail/color-detail.component';
import {ThemeExpanderComponent} from './component/theme-expander/theme-expander.component';
import {PaletteExpanderComponent} from './component/palette-expander/palette-expander.component';
import {PaletteStripComponent} from './component/palette-strip/palette-strip.component';
import {ScreenshotsPageComponent} from './page/landing-layout/screenshots-page/screenshots-page.component';
import {PinterestPageComponent} from './page/landing-layout/temp-pages/pinterest-page/pinterest-page.component';
import {PinterestCardComponent} from './component/card/pinterest-card/pinterest-card.component';
import {LinePageComponent} from './page/landing-layout/temp-pages/line-page/line-page.component';
import {LineCardComponent} from './component/card/line-card/line-card.component';
import {LineMenuBgComponent} from './component/card/line-menu-bg/line-menu-bg.component';
import {LineChatBgComponent} from './component/card/line-chat-bg/line-chat-bg.component';
import {LinePasscodeComponent} from './component/card/line-passcode/line-passcode.component';
import {LineMenuButtonComponent} from './component/card/line-menu-button/line-menu-button.component';
import {LineTowerGlyphComponent} from './component/card/line-tower-glyph/line-tower-glyph.component';
import {LineProfileComponent} from './component/card/line-profile/line-profile.component';
import {LineHomeComponent} from './component/card/line-home/line-home.component';
import {LineLockComponent} from './component/card/line-lock/line-lock.component';
import {LineThumbnailComponent} from './component/card/line-thumbnail/line-thumbnail.component';
import {ThemePageComponent} from './page/landing-layout/theme-page/theme-page.component';
import {ImgFallbackDirective} from './directive/img-fallback/img-fallback.directive';
import {DriftDirective} from './directive/drift/drift.directive';
import {StuckDirective} from './directive/stuck/stuck.directive';
import {ToBodyDirective} from './directive/to-body/to-body.directive';
import {LightboxZoomDirective} from './directive/lightbox-zoom/lightbox-zoom.directive';
import {GeneratorPickerComponent} from './component/generator-picker/generator-picker.component';
import {BlogListPageComponent} from './page/landing-layout/blog-pages/blog-list-page/blog-list-page.component';
import {BlogPostPageComponent} from './page/landing-layout/blog-pages/blog-post-page/blog-post-page.component';
import {ToastComponent} from './component/toast/toast.component';
import {CartPageComponent} from './page/landing-layout/cart-page/cart-page.component';
import {OrderPageComponent} from './page/landing-layout/order-page/order-page.component';
import {OrderFindPageComponent} from './page/landing-layout/order-find-page/order-find-page.component';
import {StoreTermsPageComponent} from './page/landing-layout/policy-pages/store-terms-page/store-terms-page.component';
import {StoreItemCardComponent} from './component/store/store-item-card/store-item-card.component';
import {StorePanelComponent} from './component/store/store-panel/store-panel.component';
import {StoreGuidesComponent} from './component/store/store-guides/store-guides.component';
import {StoreReviewFormComponent} from './component/store/store-review-form/store-review-form.component';
import {StoreReviewsComponent} from './component/store/store-reviews/store-reviews.component';
import {ToolRatingComponent} from './component/tool-rating/tool-rating.component';
import {MiniCartComponent} from './component/store/mini-cart/mini-cart.component';
import {ContactPopoverComponent} from './component/nav/contact-popover/contact-popover.component';
import {ContactFormComponent} from './component/nav/contact-form/contact-form.component';
import {StoreSuggestionsComponent} from './component/store/store-suggestions/store-suggestions.component';
import {ColorConverterComponent} from './component/blog/color-converter/color-converter.component';
import {HarmonyPreviewComponent} from './component/blog/harmony-preview/harmony-preview.component';
import {ReadabilityPreviewComponent} from './component/blog/readability-preview/readability-preview.component';
import {LightMixerComponent} from './component/blog/light-mixer/light-mixer.component';
import {ColorWheelComponent} from './component/blog/color-wheel/color-wheel.component';
import {SaturationWheelComponent} from './component/blog/saturation-wheel/saturation-wheel.component';
import {ValueLadderComponent} from './component/blog/value-ladder/value-ladder.component';
import {ValueRiseComponent} from './component/blog/value-rise/value-rise.component';
import {ModeRoomComponent} from './component/blog/mode-room/mode-room.component';
import {GradientPreviewComponent} from './component/blog/gradient-preview/gradient-preview.component';
import {HwbMixerComponent} from './component/blog/hwb-mixer/hwb-mixer.component';
import {CmykMixerComponent} from './component/blog/cmyk-mixer/cmyk-mixer.component';
import {ThemePaletteComponent} from './component/blog/theme-palette/theme-palette.component';
import {ScreenshotDeckComponent} from './component/blog/screenshot-deck/screenshot-deck.component';
import {CgSelectComponent} from './component/cg-select/cg-select.component';
import {ColorBlindnessComponent} from './component/blog/color-blindness/color-blindness.component';
import {CircuitLinesComponent} from './component/design/circuit-lines/circuit-lines.component';
import {StatusStateComponent} from './component/status-state/status-state.component';

@NgModule({
  declarations: [
    ImgFallbackDirective,
    DriftDirective,
    StuckDirective,
    ToBodyDirective,
    LightboxZoomDirective,
    GeneratorPickerComponent,
    BannerNotesComponent,
    BannerComponent,
    BadgeComponent,
    FreeFlagComponent,
    AppComponent,
    IconComponent,
    HomePageComponent,
    HeroCircuitComponent,
    HeroAuroraComponent,
    HeroSakuraComponent,
    HeroAutumnComponent,
    HeroEverestComponent,
    HeroSequoiaComponent,
    HeroRoraimaComponent,
    HeroSaldaComponent,
    HeroOceanComponent,
    HeroSpringComponent,
    HeroReynisfjaraComponent,
    HeroFujiComponent,
    HeroEtnaComponent,
    HeroIstanbulComponent,
    HeroMiamiComponent,
    HeroRioDeJaneiroComponent,
    HeroParisComponent,
    HeroTallinnComponent,
    HeroTokyoComponent,
    HeroSydneyComponent,
    HeroPragueComponent,
    HeroMadridComponent,
    HeroViennaComponent,
    HeroDublinComponent,
    HeroLondonComponent,
    HeroBioluminescenceComponent,
    ProductShowcaseComponent,
    ThemeShowcaseComponent,
    ReviewShowcaseComponent,
    CoverageMatrixComponent,
    ToolsShowcaseComponent,
    PaletteShowcaseComponent,
    BlogShowcaseComponent,
    LandingLayoutComponent,
    LandingLayoutTopNavComponent,
    ToolsLayoutComponent,
    BottomNavComponent,
    FooterComponent,
    SplashLayoutComponent,
    NotFoundPageComponent,
    MaintenancePageComponent,
    CookiePopupComponent,
    ThemeOfferPopupComponent,
    CookiePolicyPageComponent,
    PrivacyPolicyPageComponent,
    TermsPageComponent,
    LangmiPageComponent,
    LangmiPrivacyPageComponent,
    LangmiPrivacyLocalizedPageComponent,
    LangmiTermsPageComponent,
    LangmiTeacherTermsPageComponent,
    ThemeLicensePageComponent,
    ThemePrivacyPageComponent,
    DockTownPrivacyPageComponent,
    AiTokenMeterPrivacyPageComponent,
    TidyDesktopPrivacyPageComponent,
    TestimonialCardComponent,
    ReviewCardComponent,
    ReviewWallComponent,
    DropdownMenuComponent,
    ColorChartComponent,
    ExtLinkComponent,
    ExternalRedirectPageComponent,
    ContactUsPageComponent,
    EmployeeCardComponent,
    PolicyCardComponent,
    BrandingPageComponent,
    PresentationCardComponent,
    ColorWidgetComponent,
    ConverterHeroComponent,
    PaletteWidgetComponent,
    GradientWidgetComponent,
    WallpaperWidgetComponent,
    CodeImageWidgetComponent,
    CodigrateLoaderComponent,
    ContentLoaderComponent,
    ImageContentLoaderComponent,
    TextContentLoaderComponent,
    BoxContentLoaderComponent,
    SitemapPageComponent,
    FeatureCardComponent,
    ColorPageComponent,
    PalettePageComponent,
    GradientPageComponent,
    WallpaperPageComponent,
    DynamicWallpaperPageComponent,
    CodeImagePageComponent,
    ContrastPageComponent,
    ContrastWidgetComponent,
    CvdPageComponent,
    AiCostPageComponent,
    AiPriceWatchPageComponent,
    AiCostWidgetComponent,
    AiPriceWatchWidgetComponent,
    CvdWidgetComponent,
    ToolAboutComponent,
    MoreToolsComponent,
    ConverterPageComponent,
    ToolsPageComponent,
    ChromeColorPickerPageComponent,
    JetbrainsColorPickerPageComponent,
    VscodeColorPickerPageComponent,
    MacosColorPickerPageComponent,
    MacosTidyDesktopPageComponent,
    MacosDockTownPageComponent,
    MacosAiTokenMeterPageComponent,
    AllInOneThemesPageComponent,
    PluginsPageComponent,
    ThemesPageComponent,
    PalettesPageComponent,
    ColorPalettePageComponent,
    ThemePageComponent,
    ToastComponent,
    CartPageComponent,
    OrderPageComponent,
    OrderFindPageComponent,
    StoreTermsPageComponent,
    StoreItemCardComponent,
    StorePanelComponent,
    StoreGuidesComponent,
    StoreReviewFormComponent,
    StoreReviewsComponent,
    ToolRatingComponent,
    MiniCartComponent,
    ContactPopoverComponent,
    ContactFormComponent,
    StoreSuggestionsComponent,
    ScreenshotsPageComponent,
    PinterestPageComponent,
    PinterestCardComponent,
    LinePageComponent,
    LineCardComponent,
    LineMenuBgComponent,
    LineChatBgComponent,
    LinePasscodeComponent,
    LineMenuButtonComponent,
    LineTowerGlyphComponent,
    LineProfileComponent,
    LineHomeComponent,
    LineLockComponent,
    LineThumbnailComponent,
    AssetCardComponent,
    ThemeCardComponent,
    ColorDetailComponent,
    ThemeExpanderComponent,
    PaletteExpanderComponent,
    PaletteStripComponent,
    BlogHolderCardComponent,
    BlogListPageComponent,
    BlogPostPageComponent,
    ColorConverterComponent,
    HarmonyPreviewComponent,
    ReadabilityPreviewComponent,
    LightMixerComponent,
    ColorWheelComponent,
    SaturationWheelComponent,
    ValueLadderComponent,
    ValueRiseComponent,
    ModeRoomComponent,
    GradientPreviewComponent,
    HwbMixerComponent,
    CmykMixerComponent,
    ThemePaletteComponent,
    ScreenshotDeckComponent,
    CgSelectComponent,
    ColorBlindnessComponent,
    CircuitLinesComponent,
    StatusStateComponent,
    ContactInformationCardComponent,
    ArrowRightComponent,
    ArrowLeftComponent,
    ProgressBarComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    DragDropModule,
    HttpClientModule,
    BrowserAnimationsModule,
    LayoutModule,
    FormsModule,
    CardModule,
    ButtonModule,
    AnimatedCodeEditorModule,
    HeroModule,
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
